import { useState } from 'react'
import SearchFilter from './searchFilter'
import SearchResult from './searchResult'
import SearchPageControl from './searchPageControl'

const SearchPage = (props) => {
    const [currentPage, setCurrentPage] = useState(1)
    const changeCurrentPage = (newPageNumber) => {
        const upperLimit = newPageNumber * props.resultsPerPage
        const lowerLimit = upperLimit - props.resultsPerPage + 1

        props.searchFunction(lowerLimit, upperLimit)
        setCurrentPage(newPageNumber)
        document.getElementById("find-ace-pro-results").scrollIntoView()
    }

    return (
        <section>
            {props.showLoadingIndicator ? <div>Loading...</div> : null}
            {props.totalResults > 0 && (props.results[0].CountryName === 'US' || props.results[0].CountryName === 'USA')
                ?
                <div>
                    <p className="ace-pro-location-search__result-data">
                        We have located <span className="text-green">{props.totalResults} ACE Pros</span> within {props.radius} miles of <span className="text-green">{props.country} - {props.zip}</span>
                    </p>
                    <SearchFilter setSortByFunction={props.setSortByFunction} sortBy={props.sortBy} />
                </div>
                : null}
            {props.results.map((r) => {
                return <SearchResult result={r} />
            })}
            {props.results.length < 1 && !props.showLoadingIndicator
                ? <div>No Results. Please try another search term.</div>
                : null}
            {props.totalResults > props.resultsPerPage
                ? <SearchPageControl
                    currentPage={currentPage}
                    numberOfPages={Math.ceil(props.totalResults / props.resultsPerPage)}
                    pageNavigationFunction={changeCurrentPage}
                />
                : null}
        </section>
    )
}

export default SearchPage